export const classRegistrant = {
  firstName: '',
  lastName: '',
  role: '',
  email: '',
  phone: '',
  smsOptIn: false,
  orgName: '',
  orgStreet: '',
  orgCity: '',
  orgStateCode: '',
  orgPostalCode: '',
  orgPhone: '',
  classStartDay: '',
  classCampaignId: '',
  leadSource: '',
  leadType: '',
  formSource: '',
  formType: '',
  signupTrackId: '',

  setName: function (name) {
    const nameArray = name.split(' ');
    this.firstName = nameArray[0];
    nameArray.shift();
    this.lastName = nameArray.toString().replace(/,/g, ' ');
  },

  getName: function () {
    return this.firstName.concat(' ').concat(this.lastName);
  },

  populate: function (form) {
    let allElements = form.elements;

    this.setName(allElements.namedItem('customerName').value);
    this.role = allElements.namedItem('businessRole').value;
    this.email = allElements.namedItem('customerEmail').value;
    this.phone = allElements.namedItem('customerPhone').value;
    this.smsOptIn = allElements.namedItem('smsOptIn').checked;
    this.orgName = allElements.namedItem('organizationName').value;
    this.orgStreet = allElements.namedItem('organizationAddress').value;
    this.orgCity = allElements.namedItem('organizationCity').value;
    this.orgStateCode = allElements.namedItem('organizationState').value;
    this.orgPostalCode = allElements.namedItem('organizationPostalCode').value;
    this.orgPhone = allElements.namedItem('organizationPhone').value;
    this.classCampaignId = allElements.namedItem('campaignId').value;
    this.leadSource = allElements.namedItem('leadSource').value;
    this.leadType = allElements.namedItem('leadType').value;
    this.formSource = allElements.namedItem('formSource').value;
    this.formType = allElements.namedItem('formType').value;
    this.signupTrackId = self.crypto.randomUUID();
  }
};
